module.exports = __webpack_public_path__ + "static/media/apple.aa40d550.svg";